query studentDataload($id: ID!){
  studentDataload(id: $id) {
    id
    canCurrentEdit
    status
    data
    team {
      id
    }
    teacher {
      id
    }
    insertedAt(tz: "America/Chicago")
  }
}
